import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LabelledTextField from '../LabelledTextField';
import { dateOptions } from '../../utils/dates';
import CircleButton from '../CircleButton';
import { faEye, faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const FlowDeviceTableRow = ({ flowDevice, onDelete }) => {
    const [startDelete, setStartDelete] = useState(false);

    return (
        <tr id={flowDevice.id}>
            <td>{flowDevice.name}</td>
            <td>{flowDevice.diameter}</td>
            <td>{flowDevice.defaultDevice ? 'Yes' : 'No'}</td>
            <td className="action-cell">
                <div className="list-actions">
                    <Link to={`flowDevices/${flowDevice.id}/edit`}>
                        <CircleButton icon={faEdit} type="primary" title="Edit" />
                    </Link>
                    <CircleButton icon={faTrashAlt} type="danger" title="Delete" onClick={() => setStartDelete(true)} />
                </div>
                {startDelete && (
                    <div className="row-confirm">
                        <div className="form-actions">
                            <span>Are you sure you want to delete this record?</span>
                            <button type="button" className="btn btn-primary" onClick={() => onDelete(flowDevice.id)}>Yes</button>
                            <button type="button" className="btn btn-secondary" onClick={() => setStartDelete(false)}>No</button>
                        </div>
                    </div>
                )}
            </td>
        </tr>
    );
};

export default FlowDeviceTableRow;